module.exports = __webpack_public_path__ + "img/TheosLogo.8a33e028.svg";